"use client";

import LoginModal from '@/components/LoginModal';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import React, { useState } from 'react';

type TopRightMenuProps = {
	phoneNumber: string | null;
	isLoading: boolean;
};


const TopRightMenu: React.FC<TopRightMenuProps> = ({ phoneNumber, isLoading }) => {
	return (
		<>
			<div className="fixed right-0 px-4 flex items-center justify-between h-[72px] z-30">
				<div className="flex items-center space-x-4">
					{isLoading ? (<button
						className="text-sm px-4 py-2 rounded-lg border-2 border-purple-500 text-transparent bg-purple-100 animate-pulse cursor-not-allowed w-20"
						disabled
					>
						&nbsp;
					</button>) : (
						<>
							{phoneNumber != null ? (
								<Link href="/profile">
									<button className="px-4 py-2 bg-white text-purple-900 border border-purple-900 rounded-lg hover:bg-gray-100">
										{phoneNumber} <FontAwesomeIcon icon={faUserCircle}></FontAwesomeIcon>
									</button>
								</Link>
							) : (
								<Link href="/login">
								<button className="px-4 py-2 bg-white text-purple-900 border border-purple-900 rounded-lg hover:bg-gray-100">
									Нэвтрэх
								</button>
								</Link>
							)}
						</>
					)}
				</div>
			</div>
		</>

	);
};

export default TopRightMenu;